import { Expose } from 'class-transformer';
import { IsNotEmpty, IsUUID } from 'class-validator';

export class ChallengeChangeMfaRequestDto {
    @Expose()
    @IsUUID()
    @IsNotEmpty()
    mfaMethodId: string;
}
